import { faqs } from "@/mocks/faqs";
import FaqAccordion from "@/components/feature/FaqAccordion";
import SubscribeForm from "@/components/feature/SubscribeForm";

export default function HomeFaq() {
  return (
    <section className="w-full bg-background-50 border-b border-background-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-wide text-accent-700 mb-2">
              <span className="w-4 h-[2px] bg-accent-500 inline-block"></span>
              常见问题
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
              关于黑吃瓜网，你可能想问
            </h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              如果下面的问题没有覆盖到你的疑问，可以通过联系我们页面的表单留言，我们会在两个工作日内回复。
            </p>
            <div className="mt-6 p-5 rounded-lg border border-primary-200 bg-primary-50">
              <h3 className="font-heading font-bold text-base text-primary-900">每周精选订阅</h3>
              <p className="mt-1.5 text-sm text-primary-800 leading-relaxed">
                不想天天刷？订阅后每周收到一封当周热门话题回顾。
              </p>
              <div className="mt-4">
                <SubscribeForm />
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <FaqAccordion items={faqs} />
          </div>
        </div>
      </div>
    </section>
  );
}